/**
 * The platform's one tier ladder, as Platform, Settings, Organization
 * tiers names it (served in APP_SETTINGS.tiers). Every page that names a
 * type takes the name from here, so a rename there renames everywhere.
 */
const FALLBACK: Record<string, string> = {
  community: "Community",
  team: "Level 1",
  business: "Level 2",
  enterprise: "Level 3",
};

type Tier = { key: string; label: string };

export const tiers = (): Tier[] => {
  const given = (window as unknown as { APP_SETTINGS?: { tiers?: Tier[] } }).APP_SETTINGS?.tiers;
  return given?.length ? given : Object.entries(FALLBACK).map(([key, label]) => ({ key, label }));
};

export const tierName = (key: string): string => tiers().find((t) => t.key === key)?.label ?? FALLBACK[key] ?? key;

/** The types that can be bought: the ladder above community. */
export const paidTiers = (): Tier[] => tiers().filter((t) => t.key !== "community");
